<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Payments /</span> Payments Transactions
        </h4>

        <mat-card>
            <mat-card-header class="mt-3 mb-4">
                <mat-icon>payments</mat-icon>Payment Transactions Details
            </mat-card-header>
            <mat-card-content>
                <hr class="my-0 mt-3 mb-4" />
                <form [formGroup]="transactionDetailsForm">
                    <mat-card-content>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-card class="mb-3">
                                    <mat-card-header class="mt-2 mb-2">
                                        <mat-icon
                                            style="margin-right: 8px;margin-top: -0.3px;">information</mat-icon>Billing
                                        Information</mat-card-header>
                                    <mat-card-content>
                                        <mat-grid-list cols="2" rowHeight="330px">
                                            <mat-grid-tile>
                                                <div class="adminControls">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Lender</mat-label>
                                                        <input matInput formControlName="lender" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Loan Number</mat-label>
                                                        <input matInput formControlName="loanNum" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Actual Settlement</mat-label>
                                                        <input matInput formControlName="ActualSettlement" readonly>
                                                    </mat-form-field>
                                                </div>
                                            </mat-grid-tile>

                                            <mat-grid-tile>
                                                <div class="adminControls">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Tracking Number</mat-label>
                                                        <input matInput formControlName="trackingNum" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Borrower</mat-label>
                                                        <input matInput formControlName="borrower" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Property</mat-label>
                                                        <input matInput formControlName="property" readonly>
                                                    </mat-form-field>
                                                </div>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                    </mat-card-content>
                                </mat-card>
                            </div>


                            <div class="col-md-6">
                                <mat-card class="mb-3">
                                    <mat-card-header class="mt-2 mb-2">
                                        <mat-icon
                                            style="margin-right: 8px;margin-top: -0.3px;">information</mat-icon>Service
                                        Information</mat-card-header>
                                    <mat-card-content>
                                        <mat-grid-list cols="2" rowHeight="450px">
                                            <mat-grid-tile>
                                                <div class="adminControls">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Service Type</mat-label>
                                                        <mat-select formControlName="serviceType" value="B" readonly>
                                                            <mat-option value="A">Service A</mat-option>
                                                            <mat-option value="B">Apparisal Fee Service</mat-option>
                                                            <mat-option value="C">Service B</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Service Items</mat-label>
                                                        <input matInput formControlName="serviceItems" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Service Charge</mat-label>
                                                        <input matInput formControlName="serviceCharge" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Cancel Date</mat-label>
                                                        <input matInput formControlName="cancelDate" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>AFS Status</mat-label>
                                                        <input matInput formControlName="afsPaymentStatus" readonly>
                                                    </mat-form-field>
                                                </div>
                                            </mat-grid-tile>

                                            <mat-grid-tile>
                                                <div class="adminControls">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Order Date</mat-label>
                                                        <input matInput formControlName="orderDate" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Settle Date</mat-label>
                                                        <input matInput formControlName="settleDate" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Completion Date</mat-label>
                                                        <input matInput formControlName="completionDate" readonly>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Remit Date</mat-label>
                                                        <input matInput formControlName="remitDate" readonly>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" style="visibility: hidden;">
                                                        <mat-label>AFS Status</mat-label>
                                                        <input matInput readonly>
                                                    </mat-form-field>
                                                </div>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </mat-card-content>
                </form>
            </mat-card-content>
        </mat-card>

        <!-- remittance -->
        <mat-card class="mt-3">
            <mat-card-header class="mt-3 mb-4">
                <mat-icon>payments</mat-icon>Remittances
            </mat-card-header>
            <mat-card-content>
                <div class="card">
                    <table mat-table #outerRemitsort="matSort" [dataSource]="remitDataSource" multiTemplateDataRows
                        class="mat-elevation-z8" matSort>
                        <ng-container matColumnDef="{{column}}"
                            *ngFor="let column of displayedRemittanceParentColumns; let i = index">
                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="i">
                                {{
                                column === 'formattedRemittedDate' ? 'Remit Date' :
                                column === 'completionDate' ? 'Completion Date' :
                                column === 'numberOfOrders' ? '# of Orders' :
                                column === 'refundAmount' ? 'Refund Amount' :
                                column === 'actualSettlementAmount' ? 'Settle Amount' :
                                column === 'remittance' ? 'Remittance' : column
                                }}
                            </th>
                            <!-- <td mat-cell *matCellDef="let element">
                            {{element[column]}}</td> -->

                            <td mat-cell *matCellDef="let element">
                                <div *ngIf="column==='actualSettlementAmount' || column==='remittance'; else elseBlock"
                                    style="text-align: right;">
                                    {{'$ '+element[column]}}
                                </div>
                                <ng-template #elseBlock>
                                    {{element[column]}}
                                </ng-template>
                            </td>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element"
                                [attr.colspan]="displayedRemittanceParentColumns.length">
                                <div class="example-element-detail" *ngIf="element.remittedPayments?.data"
                                    [@detailExpand]="element == expandedRemit ? 'expanded' : 'collapsed'">
                                    <div class="inner-table mat-elevation-z8" *ngIf="expandedRemit">
                                        <div class="settleData">
                                            <!-- <button mat-raised-button class="search"
                                                (click)="downloadInnerRemitExcel(element.remittedPayments.data)"><mat-icon
                                                    class="nav-icon">download</mat-icon>Download Excel
                                            </button> -->
                                        </div>
                                        <mat-form-field>
                                            <input matInput (keyup)="applyRemitFilter($event.target.value)"
                                                placeholder="Filter" />
                                        </mat-form-field>
                                        <table #innerRemitTables innerRemitPaginator mat-table #innerRemitSort="matSort"
                                            [dataSource]="element.remittedPayments" matSort>
                                            <ng-container matColumnDef="{{innerColumn}}"
                                                *ngFor="let innerColumn of displayedRemittanceChildColumns; let i=index">
                                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="i">
                                                    {{
                                                    innerColumn === 'loanNumber' ? 'Loan Number' :
                                                    innerColumn === 'borrower' ? 'Borrower Name' :
                                                    innerColumn === 'propertyAddress' ? 'Property Address' :
                                                    innerColumn === 'partyName' ? 'Lender Name' :
                                                    innerColumn === 'orderDate' ? 'Order Date' :
                                                    innerColumn === 'remittanceDate' ? 'Remit Date' :
                                                    innerColumn === 'refundAmount' ? 'Refund Amount' :
                                                    innerColumn === 'formattedActualSettlementAmount'
                                                    ?'Settle Amount' :
                                                    innerColumn === 'formattedRemittanceAmount' ?
                                                    'Remittance Amount' : innerColumn
                                                    }}

                                                </th>
                                                <!-- <td mat-cell *matCellDef="let element">
                                                {{element[innerColumn]}}
                                            </td> -->
                                                <td mat-cell *matCellDef="let element">
                                                    <div *ngIf="innerColumn==='formattedActualSettlementAmount' || innerColumn==='formattedRemittanceAmount' || innerColumn==='refundAmount'; else elseBlock"
                                                        style="text-align: right;">
                                                        {{element[innerColumn]}}
                                                    </div>
                                                    <ng-template #elseBlock>
                                                        {{element[innerColumn]}}
                                                    </ng-template>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedRemittanceChildColumns">
                                            </tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedRemittanceChildColumns;">
                                            </tr>
                                        </table>
                                        <mat-card-actions>
                                            <mat-paginator #innerRemitPaginator [pageSize]="5"
                                                [length]="element.remittedPayments.data.length" [pageIndex]="0"
                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                        </mat-card-actions>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedRemittanceParentColumns"></tr>
                        <tr mat-row *matRowDef="let element; columns: displayedRemittanceParentColumns;"
                            [class.example-element-row]="element.remittedPayments?.data"
                            [class.example-expanded-row]="expandedRemit === element" (click)="toggleRemitRow(element)">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                    </table>
                </div>
                <mat-card-actions>
                    <div class="text-align mt-3">
                        <mat-paginator #remitPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]">
                        </mat-paginator>
                    </div>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>

        <!-- refunds -->
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right:10px">
                    monetization_on
                </span>Refunds
            </mat-card-header>
            <mat-card-actions>
                <div class="text-align">
                    <button mat-raised-button class="search"
                       [disabled]="isRefund==0 && isCancelled==0 && refundAttempts==0"
                        [disabled]="this.transactionDetailsForm.value.serviceCharge <= this.refundAmount"
                        (click)="openDialog()"><i class="material-icons">add</i>
                        Raise Refund
                        Request</button>
                </div>
            </mat-card-actions>

            <mat-card-content>
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="navs-pills-justified-tablesuccess" role="tabpanel">
                        <div class="card">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                <ng-container matColumnDef="srNo">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No</th>
                                    <td mat-cell *matCellDef="let item; let j = index">
                                        {{ (j+1) + (refund.pageIndex * refund.pageSize) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="refundReqOn">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">Refund
                                        Requested On</th>
                                    <td mat-cell *matCellDef="let element">{{element.refundDate | date:'M/d/yyyy'}}</td>
                                </ng-container>

                                <ng-container matColumnDef="transRefNo">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">Transaction
                                        Reference No</th>
                                    <td mat-cell *matCellDef="let element"
                                        (click)="getRefundDetailsById(element.refundRequestId)"
                                        style="color: blue; cursor: pointer;"> {{element.afsTransactionId}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="refundAmount">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">Refund
                                        Amount</th>
                                    <td mat-cell *matCellDef="let element" style="text-align: right;">
                                        $&#8239;{{element.refundAmount}} </td>
                                </ng-container>


                                <ng-container matColumnDef="refundStatus">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">Refund
                                        Status</th>
                                        <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==0 && element.refundAttempts==0">{{'Refund Processed'}}</div>
                                            <div *ngIf="element.isRefunded==1">{{'Refunded'}}</div>
                                            <div *ngIf="element.isCancelled==1 && element.isRefunded==0">{{'Refund Cancelled'}}</div>
                                            <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}
                                           </div>
                                        </td>
                                        <!-- <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div>
                                            <div *ngIf="element.isRefunded==1 && element.isCancelled==0">{{'Refunded'}}</div>
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==1 && element.refundAttempts==0">{{'Refund Cancelled'}}</div>
                                            <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{'Refunded'}}</div>
                                            <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}
                                           </div>
                                        </td> -->
                                </ng-container>

                                <ng-container matColumnDef="cancel">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">Cancel
                                        Refund</th>

                                        <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.isCancelled==0 && element.isRefunded==0 && element.refundAttempts==0">
                                                <button type="button" class="btn btn-primary mb-3 mt-3"
                                                    (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                            </div>
                                            <!-- <div *ngIf="element.isCancelled==1 && element.isRefunded==1">Can't cancelled</div>
                                            <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 ">{{'Refund Failed'}}</div> -->
                                            <!-- <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div> -->
                                            <div *ngIf="element.isRefunded==1">{{"Can't Cancelled"}}
                                            </div>
                                            <div
                                                *ngIf="element.isCancelled==1  && element.isRefunded==0">
                                                {{'Refund Cancelled'}}</div>
                                            <!-- <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div> -->
                                            <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}</div>
                                        </td>
                                    <!-- <td mat-cell *matCellDef="let element">
                                        <div *ngIf="!element.isCancelled && !element.isRefunded">
                                            <button type="button" class="btn btn-primary mb-3 mt-3"
                                                (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                        </div>
                                        
                                        <div *ngIf="element.isRefunded==1 && !element.isCancelled">{{"Can't Cancelled"}}
                                        </div>
                                        <div
                                            *ngIf="!element.refundAttempts && !element.isRefunded && element.isCancelled==1">
                                            {{'Refund Cancelled'}}</div>
                                        <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div>
                                        <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}</div>
                                    </td> -->
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="6">No data matching the filter
                                    </td>
                                    <!-- "{{input.value}}" -->
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <mat-card-actions>
                    <div class="text-align mt-3">
                        <mat-paginator #refund [length]="totalCount" [pageSize]="pageSize" [pageIndex]="pageIndex"
                            [pageSizeOptions]="[5, 10, 15, 100]" (page)="onPageChange($event)">
                        </mat-paginator>
                    </div>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>

        <!-- back button -->
        <div class="mt-4" style="margin-left: 35px;">
            <mat-card-content>
                <button mat-raised-button class="buttonRow" (click)="goBack()"><span class="material-symbols-outlined"
                        style="margin-right: 5px ;">
                        keyboard_return
                    </span>Go Back</button>
            </mat-card-content>
        </div>
    </div>
</div>
<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>